import React, { useState } from "react";
import { mdiContentCopy, mdiEye, mdiEyeOff, mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";
import styles from "./style.module.scss";

export interface ApiKeyInputProps {
  label?: string;
  value: string;
  onCopy?: (value: string) => void;
  isFetching?: boolean;
}

const ApiKeyInput: React.FC<ApiKeyInputProps> = ({ label, value, onCopy, isFetching = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    if (onCopy) onCopy(value);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 2000);
  };

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <div className={`${styles.smartInputContainer} w-full relative`}>
      {label && <label className={styles.smartInputLabel}>{label}</label>}
      <div className={`${styles.smartInputWrapper} relative flex items-center`}>
        <input
          type={isVisible ? "text" : "password"}
          value={value}
          readOnly
          className={`${styles.smartInput} bg-input text-tertiary pr-32`}
        />
        {isFetching ? (
          <div className="absolute right-16 flex items-center text-blue-500 animate-spin">
            <Icon path={mdiLoading} size={1} />
          </div>
        ) : (
          <div className="relative">
            <button
              type="button"
              onClick={handleCopy}
              className="absolute right-16 top-1/2 transform -translate-y-1/2 flex items-center text-primary hover:text-primary-dark">
              <Icon path={mdiContentCopy} size={1} />
            </button>
            {showTooltip && (
              <div className="absolute top-[-30px] right-0 bg-black text-white text-sm px-2 py-1 rounded shadow-md">
                Copied!
              </div>
            )}
          </div>
        )}
        <button
          type="button"
          onClick={toggleVisibility}
          className={`${styles.smartInputPasswordIcon} absolute right-4 top-1/2 transform -translate-y-1/2`}>
          <Icon path={isVisible ? mdiEyeOff : mdiEye} size={1} />
        </button>
      </div>
    </div>
  );
};

export default ApiKeyInput;
